export const encrypt: Record<string, string> = {
  // Tab labels
  'encrypt.tab.projects': 'Sản phẩm',
  'encrypt.tab.encrypt': 'Mã hóa',
  'encrypt.tab.decrypt': 'Giải mã',

  // Projects tab
  'encrypt.projects.title': 'Sản phẩm Encrypt',
  'encrypt.projects.addProject': 'Thêm sản phẩm',
  'encrypt.projects.code': 'Mã',
  'encrypt.projects.name': 'Tên',
  'encrypt.projects.owner': 'Chủ sở hữu',
  'encrypt.projects.adUnits': 'Ad Units',
  'encrypt.projects.actions': 'Thao tác',
  'encrypt.projects.noProjects': 'Không có sản phẩm nào.',
  'encrypt.projects.editProject': 'Chỉnh sửa',
  'encrypt.projects.permissions': 'Phân quyền',
  'encrypt.projects.deleteProject': 'Xóa',
  'encrypt.projects.confirmDelete': 'Xóa sản phẩm và toàn bộ ad unit?',

  // Add / Edit product modal
  'encrypt.modal.addProject': 'Thêm sản phẩm',
  'encrypt.modal.editProject': 'Chỉnh sửa sản phẩm',
  'encrypt.modal.projectCode': 'Mã sản phẩm',
  'encrypt.modal.projectCodeHint': 'Chỉ chữ cái và số, ví dụ ES34',
  'encrypt.modal.projectName': 'Tên sản phẩm',
  'encrypt.modal.existingProduct': 'Sản phẩm hiện có',
  'encrypt.modal.newProduct': 'Sản phẩm mới',
  'encrypt.modal.productInfo': 'Thông tin sản phẩm',
  'encrypt.modal.requiredFields': 'Cần điền Mã và Tên sản phẩm.',
  'encrypt.modal.platformRequired': 'Cần chọn Platform cho sản phẩm mới.',
  'encrypt.modal.adKey': 'Ad Key',
  'encrypt.modal.adIv': 'Ad IV',
  'encrypt.modal.adKeyHint': 'Để trống để giữ nguyên key hiện tại',
  'encrypt.modal.adIvHint': 'Để trống để giữ nguyên IV hiện tại',

  // Permissions modal
  'encrypt.perm.title': 'Quản lý phân quyền',
  'encrypt.perm.addEmail': 'Thêm email',
  'encrypt.perm.emailPlaceholder': 'user@supernovajsc.com',
  'encrypt.perm.remove': 'Xóa',
  'encrypt.perm.noEmails': 'Chưa chia sẻ với ai.',

  // Ad units panel
  'encrypt.adunit.adName': 'Tên Ad',
  'encrypt.adunit.adUnitId': 'Ad Unit ID',
  'encrypt.adunit.encrypted': 'Đã mã hóa',

  // Encrypt tab
  'encrypt.enc.title': 'Mã hóa Ad Unit ID',
  'encrypt.enc.selectProject': 'Chọn sản phẩm',
  'encrypt.enc.adUnitId': 'Ad Unit ID',
  'encrypt.enc.adUnitIdPlaceholder': 'ca-app-pub-xxxx/yyyy',
  'encrypt.enc.result': 'Kết quả mã hóa',
  'encrypt.enc.encrypt': 'Mã hóa',
  'encrypt.enc.saveToProject': 'Lưu vào sản phẩm',
  'encrypt.enc.adName': 'Tên Ad (để lưu)',
  'encrypt.enc.saving': 'Đang lưu…',
  'encrypt.enc.saved': 'Đã lưu',
  'encrypt.enc.bulkTitle': 'Mã hóa hàng loạt',
  'encrypt.enc.bulkInput': 'Ad Unit IDs (mỗi dòng một)',
  'encrypt.enc.bulkEncrypt': 'Mã hóa tất cả',
  'encrypt.enc.bulkResults': 'Kết quả',
  'encrypt.enc.noKeyAccess': 'Bạn không có quyền xem key của sản phẩm này.',

  // Decrypt tab
  'encrypt.dec.title': 'Giải mã chuỗi',
  'encrypt.dec.selectProject': 'Chọn sản phẩm',
  'encrypt.dec.ciphertext': 'Chuỗi đã mã hóa',
  'encrypt.dec.ciphertextPlaceholder': 'Dán chuỗi mã hóa vào đây…',
  'encrypt.dec.result': 'Ad Unit ID gốc',
  'encrypt.dec.decrypt': 'Giải mã',

  // Live AdMob inventory ad units (expand row)
  'encrypt.admob.source': 'Ad units từ AdMob Mediation',
  'encrypt.admob.format': 'Định dạng',
  'encrypt.admob.noMatch': 'Không tìm thấy app AdMob khớp mã sản phẩm này (Product pAdmobID/pPkn).',
  'encrypt.admob.empty': 'App này chưa có ad unit nào trong inventory AdMob.',
  'encrypt.admob.sync': 'Sync ad units',
  'encrypt.admob.syncing': 'Đang sync…',
  'encrypt.admob.syncFailed': 'Sync thất bại.',
  'encrypt.admob.syncAllDone': 'Đã sync ad units của {n} tài khoản AdMob.',

  // Common
  'encrypt.loadingKeys': 'Đang tải khoá…',
  'encrypt.enc.failed': 'Mã hoá thất bại.',
  'encrypt.dec.failed': 'Giải mã thất bại. Kiểm tra chuỗi mã hoá và sản phẩm đã chọn.',
  'encrypt.projects.toggleAdUnits': 'Xem ad units',
  'encrypt.copy': 'Sao chép',
  'encrypt.copied': 'Đã sao chép!',
  'encrypt.errorFetch': 'Không tải được danh sách sản phẩm.',
  'encrypt.errorKeys': 'Không lấy được key sản phẩm.',
}
